import { type FunctionComponent } from 'react';
import './VizMessageError.scss';
import { I18n } from 'common/i18n';

interface VizMessageErrorProps {
  type: string;
  errorMessage: string;
}

const VizMessageError: FunctionComponent<VizMessageErrorProps> = ({ type, errorMessage }) => {
  const typeClasses = {
    noDataError: {
      imageUrl: 'https://cdn.forge.tylertech.com/v1/images/spot-hero/no-search-results-spot-hero.svg',
      headline: I18n.t('shared.no_rows_overlay.title'),
    },
    privateOrDeletedAsset: {
      imageUrl: 'https://cdn.forge.tylertech.com/v1/images/spot-hero/general-error-spot-hero.svg',
      headline: I18n.t('shared.visualizations.charts.common.validation.errors.oops_something_isnt_right'),
    },
    exceededMaxRowCount: {
      imageUrl: 'https://cdn.forge.tylertech.com/v1/images/spot-hero/too-big-error-spot-hero.svg',
      headline: I18n.t('shared.errors.exceeded_max_row_count.title'),
    },
    histogram: {
      imageUrl: 'https://cdn.forge.tylertech.com/v1/images/spot-hero/general-error-spot-hero.svg',
      headline: I18n.t('shared.visualizations.charts.common.validation.errors.oops_something_isnt_right'),
    },
    'scatter-chart': {
      imageUrl: 'https://cdn.forge.tylertech.com/v1/images/spot-hero/general-error-spot-hero.svg',
      headline: I18n.t('shared.visualizations.charts.common.validation.errors.oops_something_isnt_right'),
    },
    datasetMissingColumn: {
      imageUrl: 'https://cdn.forge.tylertech.com/v1/images/spot-hero/general-error-spot-hero.svg',
      headline: I18n.t('shared.visualizations.charts.common.validation.errors.oops_something_isnt_right'),
    },
  };

  return (
    <div className="viz-error-container" tabIndex={-1}>
      <img className="viz-error-img" src={typeClasses[type as keyof typeof typeClasses].imageUrl} alt="" />
      <div className="viz-text-section">
        <div className="forge-typography--heading4">
          {typeClasses[type as keyof typeof typeClasses].headline}
        </div>
        <p className="forge-typography--body1" dangerouslySetInnerHTML={{ __html: errorMessage }}></p>
      </div>
    </div>
  );
};

export default VizMessageError;
